<template>
    <div class="route">
        <div class="route1">
            <div class="route_one" :class="{active:$route.query.ljcode=='ms'}" @click="goto('ms')">美食
                <div class="b"></div>
            </div>
            <div class="route_one" :class="{active:$route.query.ljcode=='zs'}" @click="goto('zs')">住宿
                <div class="b"></div>
            </div>
            <div class="route_one" :class="{active:$route.query.ljcode=='cx'}" @click="goto('cx')">出行
                <div class="b"></div>
            </div>
            <div class="route_one" :class="{active:$route.query.ljcode=='yw'}" @click="goto('yw')">游玩
                <div class="b"></div>

            </div>
            <div class="route_one" :class="{active:$route.query.ljcode=='gw'}" @click="goto('gw')">购物
                <div class="b"></div>
            </div>
            <div class="route_one" :class="{active:$route.query.ljcode=='yl'}" @click="goto('yl')">娱乐
                <div class="b"></div>
            </div>
            <div class="route_one" :class="{active:$route.query.ljcode=='tc'}" @click="goto('tc')">特产
                <div class="b"></div>
            </div>
             <div class="route_one" :class="{active:$route.query.ljcode=='jd'}" @click="goto('jd')">红色景点

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "route",
        data() {
            return {}
        },
        created() {
        },
        components: {
        },
        methods: {
            goto(type){
                switch (type) {
                    case 'ms':
                        location.href = '#/list_wzlj?ljcode=ms&columnId=40288a9d6e91c70a016e91cd018f000b&rootColumnId=40288a9d6e91c70a016e91c90be20002';
                        break;
                    case 'zs':
                        location.href = '#/list_wzlj_zs?ljcode=zs&columnId=40288a9d6e91c70a016e91cd2d41000c&rootColumnId=40288a9d6e91c70a016e91c90be20002';
                        break;
                   
                    case 'cx':
                        location.href = '#/list_wzlj_cx?ljcode=cx&columnId=40288a9d6e91c70a016e91cd57a1000d&rootColumnId=40288a9d6e91c70a016e91c90be20002';
                        break;
                         case 'yw':
                        location.href = '#/list_wzlj_yw?ljcode=yw&columnId=40288a9d6e91c70a016e91cd7efb000e&rootColumnId=40288a9d6e91c70a016e91c90be20002';
                        break;
                    case 'gw':
                        location.href = '#/list_wzlj_gw?ljcode=gw&columnId=40288a9d6e91c70a016e91cdd286000f&rootColumnId=40288a9d6e91c70a016e91c90be20002';
                        break;
                    case 'yl':
                        location.href = '#/list_wzlj_yl?ljcode=yl&columnId=40288a9d6e91c70a016e91ce074a0010&rootColumnId=40288a9d6e91c70a016e91c90be20002';
                        break;
                    case 'tc':
                        location.href = '#/list_wzlj_tc?ljcode=tc&columnId=40288a9d6e91c70a016e91ce50ae0011&rootColumnId=40288a9d6e91c70a016e91c90be20002';
                        break;
                    case'jd':
                        location.href = '#/list_wzlj_jd?ljcode=jd&columnId=ff808081758d28430175912d1564005e&rootColumnId=40288a9d6e91c70a016e91c90be20002';
                    break    
                }
            }
        },
    }
</script>

<style lang="less" scoped>
    .route{
        background: rgb(13,174,236);
        .route1{
            display: flex;
            height: 50px;
            width: 1200px;
            margin: 0 auto;
            align-items: center;
            .route_one{
                height: 50px;
                line-height: 50px;
                font-size:18px;
                color: white;
                width: 170px;
                text-align: center;
                position: relative;
                .b{
                    width: 1px;
                    background: white;
                    height: 20px;
                    position: absolute;
                    right:0;
                    top:15px;

                }
                .route_two{
                    height: 50px;
                    width: 510px;
                    background: rgb(255,153,0);
                    display: none;
                    >div{
                        height: 30px;

                        font-size: 14px;
                        line-height: 30px;
                        width: 33%;
                    }
                    >div:hover{
                        background: rgb(255,173,51);
                    }


                }
            }
            .route_one:hover{
                background: rgb(255,153,0);
                .route_two{
                    display: flex;
                    align-items: center;
                }
            }
            .active{
                background: rgb(255,153,0);
            }

        }



    }
</style>
